import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ProductCard, Layout } from '../components'
import { getProducts } from '../reducks/products/selectors'
import { fetchProducts } from '../reducks/products/operations'
import { push } from 'connected-react-router'
import styled from 'styled-components'
// mui
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
// firebase
import { db } from '../firebase'

const ProductList = () => {
    const dispatch = useDispatch()
    const selector = useSelector(state=>state)
    const products = getProducts(selector)

    const [categories, setCategories] = useState([])

    const query = selector.router.location.search
    const queryString = query.substring(1)
    const parameters = queryString.split('&')
    const tempList = []
    parameters.map(parameter => {
        return tempList[parameter.split('=')[0]] = parameter.split('=')[1]
    })
    const brand = tempList['brand']
    const category = tempList['category']

    const [value, setValue] = useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    // カテゴリ一覧を取得
    useEffect(() => {
        if(brand) {
            db.collection('brands').doc(brand)
              .collection('categories').get()
              .then(snapshots => {
                  const tempCategoryList = []
                  snapshots.forEach(snapshot => {
                    tempCategoryList.push(snapshot.data())
                  })
                  setCategories(tempCategoryList)
              })
        }
        return false
    }, [brand])
    
    useEffect(() => {
        dispatch(fetchProducts(brand,category))
    },[query,dispatch, brand,category])

    return (
        <Layout>
            <div className='spacer-100' />
            <h1>Product List</h1>
            <div className='spacer-50' />

            {categories.length > 0 && (
                <Tabs value={value} onChange={handleChange} centered textColor="primary" indicatorColor="primary">
                    <Tab label="All" onClick={()=>dispatch(push('/product?brand=' + brand))}/>
                    {categories.map(cat => (
                        <Tab 
                            key={cat.id} label={cat.name}
                            onClick={()=>dispatch(push('/product?brand=' + brand + '&category=' + cat.id))} />
                    ))}
                </Tabs>
            )}

            <div className='spacer-25' />

            <ProductListWrapper>
                { products.length > 0 && (
                    products.map((product) => (
                        <ProductCard 
                            key={product.id} 
                            id={product.id} 
                            images={product.images} 
                            name={product.name}
                            price={product.price}
                            discount={product.discount}
                            isDraft={product.isDraft}
                            isTrash={product.isTrash}
                        />
                    )) 
                )}
            </ProductListWrapper>

            <div className='spacer-50'></div>
        </Layout>
    )
}

export default ProductList

const ProductListWrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 960px;
    margin: 0 auto;
    @media screen and (max-width:768px){
        width: 100%;
        justify-content: center;
    }
`